import { useMemo } from 'react'

import {
  SplitDepositDirectDepositIntentSetting,
  SplitDepositDirectDepositSetting,
  useSplitDepositSettingsByUserIdQuery,
} from 'generated/types'

type SplitDepositSettingItem =
  | SplitDepositDirectDepositIntentSetting
  | SplitDepositDirectDepositSetting

export const useSmartDeposit = (
  investmentAccountId: string | undefined,
): number | undefined => {
  const { data, loading, error } = useSplitDepositSettingsByUserIdQuery({
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    skip: !investmentAccountId,
    variables: {
      withSmartDeposit: true,
    },
  })
  const smartDepositSettings =
    data?.splitDepositSettingsByUserId as SplitDepositSettingItem[]

  const smartDepositAmount = useMemo(() => {
    if (
      loading ||
      error ||
      !investmentAccountId ||
      (smartDepositSettings ?? []).length === 0
    ) {
      return undefined
    } else {
      // TODO: Import calculateSmartDepositRecurringAmount when Potential component is migrated
      // For now, return 0 as placeholder
      return 0
    }
  }, [error, investmentAccountId, loading, smartDepositSettings])

  return smartDepositAmount
}
